/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ActiveSeverityListResultAnalyticsResponse } from '../model/active-severity-list-result-analytics-response';
// @ts-ignore
import { AnalyticsAggregationTier } from '../model/analytics-aggregation-tier';
// @ts-ignore
import { ErrorResponse } from '../model/error-response';
// @ts-ignore
import { GetEventsQueryResultAnalyticsResponse } from '../model/get-events-query-result-analytics-response';
// @ts-ignore
import { GetHealthScoresQueryResultAnalyticsResponse } from '../model/get-health-scores-query-result-analytics-response';
// @ts-ignore
import { GetProductSnapshotQueryResult } from '../model/get-product-snapshot-query-result';
// @ts-ignore
import { GetTelemetryQueryResultAnalyticsResponse } from '../model/get-telemetry-query-result-analytics-response';
// @ts-ignore
import { LifetimeOverviewAnalyticsResponse } from '../model/lifetime-overview-analytics-response';
// @ts-ignore
import { SeverityConcurrentEventsResultAnalyticsResponse } from '../model/severity-concurrent-events-result-analytics-response';
// @ts-ignore
import { SeverityIncidentDetailAnalyticsResponse } from '../model/severity-incident-detail-analytics-response';
// @ts-ignore
import { SeverityOccurrencesResultAnalyticsResponse } from '../model/severity-occurrences-result-analytics-response';
// @ts-ignore
import { SeverityPrecedingCommandsResultAnalyticsResponse } from '../model/severity-preceding-commands-result-analytics-response';
// @ts-ignore
import { SeverityTelemetryResultAnalyticsResponse } from '../model/severity-telemetry-result-analytics-response';
// @ts-ignore
import { TelemetryAggregationMode } from '../model/telemetry-aggregation-mode';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { AnalyticsApiConfiguration }                                     from '../configuration';
import {
    ProductsBackboneServiceInterface
} from './products.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ProductsBackboneService implements ProductsBackboneServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new AnalyticsApiConfiguration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: AnalyticsApiConfiguration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * List open severity incidents
     * Returns every currently-active (unresolved) severity incident across all devices in the product configuration, ordered by level then raise time. An empty list means no open incidents.
     * @param productConfigurationKey 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductActiveSeverities(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<ActiveSeverityListResultAnalyticsResponse>;
    public getProductActiveSeverities(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ActiveSeverityListResultAnalyticsResponse>>;
    public getProductActiveSeverities(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ActiveSeverityListResultAnalyticsResponse>>;
    public getProductActiveSeverities(productConfigurationKey: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductActiveSeverities.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/active`;
        return this.httpClient.request<ActiveSeverityListResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get product event log
     * Returns the unified event log scoped to a single Product Configuration. The route\&#39;s productConfigurationKey is verified against the caller\&#39;s accessible scope upfront — out-of-scope keys collapse to 403 (existence-masked).
     * @param productConfigurationKey 
     * @param deviceId 
     * @param modelIndex 
     * @param from 
     * @param to 
     * @param cursor 
     * @param pageSize 
     * @param eventTypes 
     * @param source 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductEvents(productConfigurationKey: string, deviceId?: string, modelIndex?: number, from?: string, to?: string, cursor?: string, pageSize?: number, eventTypes?: string, source?: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<GetEventsQueryResultAnalyticsResponse>;
    public getProductEvents(productConfigurationKey: string, deviceId?: string, modelIndex?: number, from?: string, to?: string, cursor?: string, pageSize?: number, eventTypes?: string, source?: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetEventsQueryResultAnalyticsResponse>>;
    public getProductEvents(productConfigurationKey: string, deviceId?: string, modelIndex?: number, from?: string, to?: string, cursor?: string, pageSize?: number, eventTypes?: string, source?: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetEventsQueryResultAnalyticsResponse>>;
    public getProductEvents(productConfigurationKey: string, deviceId?: string, modelIndex?: number, from?: string, to?: string, cursor?: string, pageSize?: number, eventTypes?: string, source?: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductEvents.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (deviceId !== undefined && deviceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deviceId, 'deviceId');
        }
        if (modelIndex !== undefined && modelIndex !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modelIndex, 'modelIndex');
        }
        if (from !== undefined && from !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>to, 'to');
        }
        if (cursor !== undefined && cursor !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>cursor, 'cursor');
        }
        if (pageSize !== undefined && pageSize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageSize, 'pageSize');
        }
        if (eventTypes !== undefined && eventTypes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventTypes, 'eventTypes');
        }
        if (source !== undefined && source !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>source, 'source');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/events`;
        return this.httpClient.request<GetEventsQueryResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get product health scores
     * Returns product health scores scoped to a single Product Configuration. Returns the current score by default; supplying from/to with deviceId returns a Shape-B timeline sourced from QuestDB tw_product_health.
     * @param productConfigurationKey 
     * @param deviceId 
     * @param from 
     * @param to 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductHealthScores(productConfigurationKey: string, deviceId?: string, from?: string, to?: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<GetHealthScoresQueryResultAnalyticsResponse>;
    public getProductHealthScores(productConfigurationKey: string, deviceId?: string, from?: string, to?: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetHealthScoresQueryResultAnalyticsResponse>>;
    public getProductHealthScores(productConfigurationKey: string, deviceId?: string, from?: string, to?: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetHealthScoresQueryResultAnalyticsResponse>>;
    public getProductHealthScores(productConfigurationKey: string, deviceId?: string, from?: string, to?: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductHealthScores.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (deviceId !== undefined && deviceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deviceId, 'deviceId');
        }
        if (from !== undefined && from !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>to, 'to');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/health-scores`;
        return this.httpClient.request<GetHealthScoresQueryResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get product lifetime overview
     * Returns a coarse-tier, lifetime-spanning summary (health line, raised-count severity bars, offline overlap segments) for the History Timeline overview band. One call per entity load; cached for 5 min L1 / 15 min L2.
     * @param productConfigurationKey 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductLifetimeOverview(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<LifetimeOverviewAnalyticsResponse>;
    public getProductLifetimeOverview(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<LifetimeOverviewAnalyticsResponse>>;
    public getProductLifetimeOverview(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<LifetimeOverviewAnalyticsResponse>>;
    public getProductLifetimeOverview(productConfigurationKey: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductLifetimeOverview.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/lifetime-overview`;
        return this.httpClient.request<LifetimeOverviewAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get concurrent severity events
     * @param productConfigurationKey 
     * @param incidentId 
     * @param windowMinutes 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSeverityConcurrentEvents(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<SeverityConcurrentEventsResultAnalyticsResponse>;
    public getProductSeverityConcurrentEvents(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeverityConcurrentEventsResultAnalyticsResponse>>;
    public getProductSeverityConcurrentEvents(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeverityConcurrentEventsResultAnalyticsResponse>>;
    public getProductSeverityConcurrentEvents(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSeverityConcurrentEvents.');
        }
        if (incidentId === null || incidentId === undefined) {
            throw new Error('Required parameter incidentId was null or undefined when calling getProductSeverityConcurrentEvents.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (windowMinutes !== undefined && windowMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>windowMinutes, 'windowMinutes');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/${this.configuration.encodeParam({name: "incidentId", value: incidentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/concurrent-events`;
        return this.httpClient.request<SeverityConcurrentEventsResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get severity incident detail
     * @param productConfigurationKey 
     * @param incidentId 
     * @param locale BCP-47 locale subset: language[2-3] optionally-region[2-3], e.g. \&#39;en\&#39;, \&#39;nl\&#39;, \&#39;fr-BE\&#39;.
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSeverityIncidentDetail(productConfigurationKey: string, incidentId: string, locale?: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<SeverityIncidentDetailAnalyticsResponse>;
    public getProductSeverityIncidentDetail(productConfigurationKey: string, incidentId: string, locale?: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeverityIncidentDetailAnalyticsResponse>>;
    public getProductSeverityIncidentDetail(productConfigurationKey: string, incidentId: string, locale?: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeverityIncidentDetailAnalyticsResponse>>;
    public getProductSeverityIncidentDetail(productConfigurationKey: string, incidentId: string, locale?: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSeverityIncidentDetail.');
        }
        if (incidentId === null || incidentId === undefined) {
            throw new Error('Required parameter incidentId was null or undefined when calling getProductSeverityIncidentDetail.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (locale !== undefined && locale !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>locale, 'locale');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/${this.configuration.encodeParam({name: "incidentId", value: incidentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<SeverityIncidentDetailAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get previous occurrences
     * @param productConfigurationKey 
     * @param incidentId 
     * @param limit 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSeverityOccurrences(productConfigurationKey: string, incidentId: string, limit?: number, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<SeverityOccurrencesResultAnalyticsResponse>;
    public getProductSeverityOccurrences(productConfigurationKey: string, incidentId: string, limit?: number, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeverityOccurrencesResultAnalyticsResponse>>;
    public getProductSeverityOccurrences(productConfigurationKey: string, incidentId: string, limit?: number, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeverityOccurrencesResultAnalyticsResponse>>;
    public getProductSeverityOccurrences(productConfigurationKey: string, incidentId: string, limit?: number, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSeverityOccurrences.');
        }
        if (incidentId === null || incidentId === undefined) {
            throw new Error('Required parameter incidentId was null or undefined when calling getProductSeverityOccurrences.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/${this.configuration.encodeParam({name: "incidentId", value: incidentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/occurrences`;
        return this.httpClient.request<SeverityOccurrencesResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get preceding MQTT Tx commands
     * @param productConfigurationKey 
     * @param incidentId 
     * @param windowMinutes 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSeverityPrecedingCommands(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<SeverityPrecedingCommandsResultAnalyticsResponse>;
    public getProductSeverityPrecedingCommands(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeverityPrecedingCommandsResultAnalyticsResponse>>;
    public getProductSeverityPrecedingCommands(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeverityPrecedingCommandsResultAnalyticsResponse>>;
    public getProductSeverityPrecedingCommands(productConfigurationKey: string, incidentId: string, windowMinutes?: number, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSeverityPrecedingCommands.');
        }
        if (incidentId === null || incidentId === undefined) {
            throw new Error('Required parameter incidentId was null or undefined when calling getProductSeverityPrecedingCommands.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (windowMinutes !== undefined && windowMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>windowMinutes, 'windowMinutes');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/${this.configuration.encodeParam({name: "incidentId", value: incidentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/preceding-commands`;
        return this.httpClient.request<SeverityPrecedingCommandsResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get severity telemetry window
     * @param productConfigurationKey 
     * @param incidentId 
     * @param windowMinutes 
     * @param bucketSeconds 
     * @param metrics 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSeverityTelemetry(productConfigurationKey: string, incidentId: string, windowMinutes?: number, bucketSeconds?: number, metrics?: Array<string>, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<SeverityTelemetryResultAnalyticsResponse>;
    public getProductSeverityTelemetry(productConfigurationKey: string, incidentId: string, windowMinutes?: number, bucketSeconds?: number, metrics?: Array<string>, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeverityTelemetryResultAnalyticsResponse>>;
    public getProductSeverityTelemetry(productConfigurationKey: string, incidentId: string, windowMinutes?: number, bucketSeconds?: number, metrics?: Array<string>, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeverityTelemetryResultAnalyticsResponse>>;
    public getProductSeverityTelemetry(productConfigurationKey: string, incidentId: string, windowMinutes?: number, bucketSeconds?: number, metrics?: Array<string>, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSeverityTelemetry.');
        }
        if (incidentId === null || incidentId === undefined) {
            throw new Error('Required parameter incidentId was null or undefined when calling getProductSeverityTelemetry.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (windowMinutes !== undefined && windowMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>windowMinutes, 'windowMinutes');
        }
        if (bucketSeconds !== undefined && bucketSeconds !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bucketSeconds, 'bucketSeconds');
        }
        if (metrics) {
            metrics.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'metrics');
            })
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/severities/${this.configuration.encodeParam({name: "incidentId", value: incidentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/telemetry`;
        return this.httpClient.request<SeverityTelemetryResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Live runtime-state snapshot for a product configuration
     * Returns the live runtime state of every device assigned to the product configuration: device info (online status, firmware, last-seen) plus per-model active severities and context values lifted from the Runtime State backplane. Server-stamps a SnapshotAt timestamp.
     * @param productConfigurationKey 
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductSnapshot(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<GetProductSnapshotQueryResult>;
    public getProductSnapshot(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetProductSnapshotQueryResult>>;
    public getProductSnapshot(productConfigurationKey: string, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetProductSnapshotQueryResult>>;
    public getProductSnapshot(productConfigurationKey: string, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductSnapshot.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/snapshot`;
        return this.httpClient.request<GetProductSnapshotQueryResult>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get product telemetry
     * Returns telemetry scoped to a single Product Configuration. The route\&#39;s productConfigurationKey is verified against the caller\&#39;s accessible scope upfront â€” out-of-scope keys collapse to 403 (existence-masked). Supports raw and per-device aggregation modes; mesh-health is reserved for the installation endpoint.
     * @param productConfigurationKey 
     * @param installationId 
     * @param deviceId 
     * @param modelIndex 
     * @param metric 
     * @param from 
     * @param to 
     * @param aggregation 0 &#x3D; Raw, 1 &#x3D; Device, 2 &#x3D; MeshHealth
     * @param tier 0 &#x3D; Raw, 1 &#x3D; QuarterHour, 2 &#x3D; Hour, 3 &#x3D; Day
     * @param org Optional organization identifier for administrative operations. When specified, allows portal administrators to manage entities belonging to organizations other than their own. This parameter is restricted to portal access only.
     * @param xApiKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProductTelemetry(productConfigurationKey: string, installationId?: string, deviceId?: string, modelIndex?: number, metric?: string, from?: string, to?: string, aggregation?: TelemetryAggregationMode, tier?: AnalyticsAggregationTier, org?: string, xApiKey?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<GetTelemetryQueryResultAnalyticsResponse>;
    public getProductTelemetry(productConfigurationKey: string, installationId?: string, deviceId?: string, modelIndex?: number, metric?: string, from?: string, to?: string, aggregation?: TelemetryAggregationMode, tier?: AnalyticsAggregationTier, org?: string, xApiKey?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetTelemetryQueryResultAnalyticsResponse>>;
    public getProductTelemetry(productConfigurationKey: string, installationId?: string, deviceId?: string, modelIndex?: number, metric?: string, from?: string, to?: string, aggregation?: TelemetryAggregationMode, tier?: AnalyticsAggregationTier, org?: string, xApiKey?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetTelemetryQueryResultAnalyticsResponse>>;
    public getProductTelemetry(productConfigurationKey: string, installationId?: string, deviceId?: string, modelIndex?: number, metric?: string, from?: string, to?: string, aggregation?: TelemetryAggregationMode, tier?: AnalyticsAggregationTier, org?: string, xApiKey?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (productConfigurationKey === null || productConfigurationKey === undefined) {
            throw new Error('Required parameter productConfigurationKey was null or undefined when calling getProductTelemetry.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (installationId !== undefined && installationId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>installationId, 'installationId');
        }
        if (deviceId !== undefined && deviceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deviceId, 'deviceId');
        }
        if (modelIndex !== undefined && modelIndex !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modelIndex, 'modelIndex');
        }
        if (metric !== undefined && metric !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>metric, 'metric');
        }
        if (from !== undefined && from !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>to, 'to');
        }
        if (aggregation !== undefined && aggregation !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>aggregation, 'aggregation');
        }
        if (tier !== undefined && tier !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tier, 'tier');
        }
        if (org !== undefined && org !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>org, 'org');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xApiKey !== undefined && xApiKey !== null) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', String(xApiKey));
        }

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/analytics/v1/products/${this.configuration.encodeParam({name: "productConfigurationKey", value: productConfigurationKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/telemetry`;
        return this.httpClient.request<GetTelemetryQueryResultAnalyticsResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
